import { useNavigate } from "react-router-dom"

export default function Banner({ banner }: { banner: { [key: string]: any } }) {

    const navigate = useNavigate();

    return (
        <div
            className="w-[280px] group select-none cursor-pointer bg-white rounded-[2rem] overflow-hidden shadow-2xl shadow-primary/10 transition-all duration-500 hover:shadow-primary/20"
            onClick={() => navigate(`/watches/${banner.slug}`)}
        >
            <div className="h-[300px] w-full relative overflow-hidden">
                <img
                    src={banner.imgUrl}
                    alt={banner.model}
                    className="object-cover h-full w-full transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                {/* Price Badge */}
                <div className="absolute bottom-4 right-4 bg-primary px-4 py-2 rounded-xl border border-secondary/30 backdrop-blur-md shadow-lg transform transition-transform group-hover:-translate-y-1">
                    <p className="text-secondary font-black text-xs md:text-sm tracking-tight">
                        R$ {banner.price.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    </p>
                </div>
            </div>

            <div className="p-6 text-center space-y-1">
                <p className="text-[10px] font-black text-mono tracking-[0.3em] uppercase opacity-60">
                    {banner.brand} | {banner.year}
                </p>
                <h3 className="font-outfit text-xl font-black text-primary tracking-tight transition-colors group-hover:text-secondary whitespace-nowrap overflow-hidden text-ellipsis">
                    {banner.model.toUpperCase()}
                </h3>
            </div>
        </div>
    )
}
